import { Component } from '@angular/core';

@Component({
  selector: 'app-crown-outline-icon',
  imports: [],
  templateUrl: './crown-outline-icon.component.html',
  standalone: true
})
export class CrownOutlineIconComponent {}
